<template>
  <a-modal
    ref="createModal"
    title="工单新增"
    :width="850"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    @ok="onConfirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="20">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="加工组织" prop="desOrganizationCode">
            <global-select
              :value.sync="form.desOrganizationCode"
              selectType="selectFilter"
              :selectData="inventOrg"
              :selectItem="{ value: 'realValue', label: 'label' }"
              @change="onChangeOrg"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划单号" prop="orderNo">
            <a-input v-model="form.orderNo" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="工单类型" prop="jobType">
            <global-select
              v-model="form.jobType"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              :setParams="{ lookupType: 'MES_MO_JOB_TYPE' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="车间" prop="workCode">
            <global-select
              :value.sync="form.workCode"
              selectType="select"
              focusGet
              requestApi="/mes/mesDiscreteJobs/workCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ organizationCode: form.desOrganizationCode }"
              @change="onChangeWorkCode"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="工作中心" prop="workCenterCode">
            <global-select
              :value.sync="form.workCenterCode"
              selectType="selectAssembleSearch"
              assembleLabel
              searchParam="centerName"
              focusGet
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ workshopCode: form.workCode }"
              @change="onChangeCenter"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="班组" prop="teamGroupCode">
            <global-select
              ref="teamGroupCodeRef"
              :value.sync="form.teamGroupCode"
              selectType="selectAssembleSearch"
              assembleLabel
              searchParam="teamName"
              focusGet
              requestApi="/bom/team/list"
              :selectItem="{ value: 'teamCode', label: 'teamName' }"
              :setParams="{ workshopCode: form.workCode }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="半成品编码" prop="assemblyItemCode">
            <global-select
              :value.sync="form.assemblyItemCode"
              selectType="selectAssembleSearch"
              :focusGet="true"
              requestApi="/mdm/mdmItemSystemItem/selectItemCodeBox"
              :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
              searchParam="itemCode"
              sourseField="res"
              :setParams="{ itemType: 'ZCBCP' }"
              :dropdown-match-select-width="false"
              :totalNum="9999999999"
              @change="globalSelectChange" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划数量" prop="planQuantity">
            <a-input-number v-model="form.planQuantity" :min="0" :precision="0" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划开始时间" prop="scheduledStartDate">
            <a-date-picker
              v-model="form.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划完成时间" prop="scheduledCompletionDate">
            <a-date-picker
              v-model="form.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="一次考核达交时间" prop="deliveryDate">
            <a-date-picker
              v-model="form.deliveryDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="备注" prop="remarks">
            <a-input v-model="form.remarks" allowClear :maxLength="100" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="MRP净值" prop="mrpFlag">
            <a-switch :checked="form.mrpFlag === 'Y'" @change="switchOnChange" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  addMesDiscreteJobsCc,
  apiGetBomTeam
} from '@/api/mes/workOrderManage/ticketsManageCc'
import { mapState } from 'vuex'
export default {
  name: 'AddModal',
  props: {},
  data () {
    return {
      confirmLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        desOrganizationCode: [
          { required: true, message: '请选择加工组织', trigger: 'change' }
        ],
        jobType: [
          { required: true, message: '请选择工单类型', trigger: 'change' }
        ],
        assemblyItemCode: [
          { required: true, message: '请选择半成品编码', trigger: 'change' }
        ],
        workCode: [
          { required: true, message: '请选择车间', trigger: 'change' }
        ],
        workCenterCode: [
          { required: true, message: '请选择工作中心', trigger: 'change' }
        ],
        teamGroupCode: [
          { required: true, message: '请选择班组', trigger: 'change' }
        ],
        planQuantity: [
          { required: true, message: '计划数量不能为空', trigger: 'blur' }
        ],
        scheduledStartDate: [
          { required: true, message: '请选择计划开始时间', trigger: 'change' }
        ],
        scheduledCompletionDate: [
          { required: true, message: '请选择计划完成时间', trigger: 'change' }
        ],
        deliveryDate: [
          { required: true, message: '请选择一次考核达交时间', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.form = this.getInitData();
    this.onChangeOrg()
  },
  methods: {
    // 成品编码
    globalSelectChange (val, list) {
      if(!val) {
        this.form.assemblyItemId = null;
        return;
      }
      const seletItem = list.find(item => item.selectedValue === val);
      this.form.assemblyItemId = seletItem.realValue
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    switchOnChange () {
      const oldMrpFlag = this.form.mrpFlag;
      this.form.mrpFlag = oldMrpFlag === "Y" ? "N" : "Y"
    },
    show () {
      this.visible = true
      this.confirmLoading = false
    },
    // 关闭模态框
    onClose () {
      this.$refs.ruleForm.resetFields();
      this.visible = false
      this.reset()
    },
    // 保存
    onConfirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.scheduledStartDate = this.$moment(this.form.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.form.scheduledCompletionDate = this.$moment(this.form.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss')
          this.form.deliveryDate = this.$moment(this.form.deliveryDate).format('YYYY-MM-DD HH:mm:ss')
          this.confirmLoading = true
          addMesDiscreteJobsCc(this.form).then(response => {
            if (response.code === 200) {
              this.$message.success('新增成功')
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('successCall')
              // 刷新表单
              this.reset()
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.form = this.getInitData();
    },
    getInitData() {
      return {
        desOrganizationCode: undefined,
        jobType: 'STANDARD',
        assemblyItemCode: undefined,
        workCode: undefined,
        planQuantity: undefined,
        orderNo: undefined,
        scheduledStartDate: undefined,
        scheduledCompletionDate: undefined,
        deliveryDate: undefined,
        remarks: undefined,
        teamGroupCode: undefined,
        workCenterCode: undefined,
        mrpFlag: 'Y'
      }
    },
    onChangeCenter(value, list) {
      this.form.teamGroupCode = undefined;
      this.$nextTick(() => {
        this.getTeam();
      })
    },
    getTeam() {
      if(!this.form.workCenterCode) {
        return;
      }
      const params = {
        centerCode: this.form.workCenterCode,
        workshopCode: this.form.workCode
      }
      apiGetBomTeam(params).then(res => {
        if(res.code === 200) {
          const { rows = [] } = res;
          const teamCode = rows[0]?.teamCode;
          if(teamCode) {
            this.form.teamGroupCode = teamCode
            this.$refs.teamGroupCodeRef.selectList = [ rows[0] ]
          }
        }
      })
    },
    onChangeWorkCode() {
      this.form.workCenterCode = undefined
      this.form.teamGroupCode = undefined
    },
    // 加工组织
    onChangeOrg () {
      this.form.assemblyItemCode = undefined
      this.form.workCode = undefined
      this.form.workCenterCode = undefined
      this.form.teamGroupCode = undefined
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 100%;
}
input{
//  width: 100%;
//}
///deep/.ant-input-number{
//  width: 180px;
}
/deep/.ant-calendar-picker{
  min-width: 100% !important;
}
/deep/.ant-form-item-control{
  min-width: 100% !important;
}
</style>
